import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import ConfirmDialog from 'scenes/IO/components/ConfirmDialog';
import { GetIOEntityName } from 'scenes/IO/helpers';
import { moreInfoIo } from 'scenes/IO/sources/io';

import { moreInfo } from '../queryKeyFactory';

export const useMoreInfoIo = (io) => {
  const entityName = GetIOEntityName(io);
  const showModal = useScreenModalV2(ConfirmDialog);
  const moreInfoMutation = useMutation(moreInfo(), moreInfoIo, {
    successMessage: () => `${entityName} more info requested`,
  });

  const handleMoreInfo = async () => {
    const { id } = io;
    const { comment, reasons } = await showModal({
      title: `Request More Info?`,
      io: io,
      confirmActionLabel: 'Request More Info',
      withTextField: true,
      withReason: true,
    });

    await moreInfoMutation.mutateAsync({ id, comment, reasons });
  };

  return [handleMoreInfo, moreInfoMutation];
};
